var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShareBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.704,
    height: 19.905,
    viewBox: "0 0 21.704 19.905",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "share_1_",
    "data-name": "share (1)",
    transform: "translate(-2.716 -0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_531",
    "data-name": "Path 531",
    d: "M195.879.655a.535.535,0,0,0-.912.379V3.887A7.3,7.3,0,0,0,190.413,5.4a8.105,8.105,0,0,0-2.813,4.711,8.3,8.3,0,0,0-.1,2.715v0l0,.024.114.653a.535.535,0,0,0,.985.183l.34-.567a7.51,7.51,0,0,1,3.874-3.426,5.615,5.615,0,0,1,2.145-.315v2.955a.535.535,0,0,0,.914.377l5.65-5.678a.535.535,0,0,0,0-.756Zm.158,10.383V8.9a.535.535,0,0,0-.45-.528,6.54,6.54,0,0,0-3.119.314,8.168,8.168,0,0,0-3.964,3.157,7.616,7.616,0,0,1,.145-1.525,6.955,6.955,0,0,1,2.453-4.1l.033-.03A6.542,6.542,0,0,1,195.5,4.948h0a.535.535,0,0,0,.535-.535V2.32L200.4,6.658Zm0,0",
    transform: "translate(-177.267 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_532",
    "data-name": "Path 532",
    d: "M19.8,70.679a.486.486,0,0,0-.475.5v2.1a1.458,1.458,0,0,1-1.424,1.488H2.373A1.459,1.459,0,0,1,.949,73.271V61.453a1.459,1.459,0,0,1,1.424-1.488H5.655a.5.5,0,0,0,0-.992H2.373A2.431,2.431,0,0,0,0,61.453V73.271a2.431,2.431,0,0,0,2.373,2.48H17.906a2.431,2.431,0,0,0,2.373-2.48v-2.1A.486.486,0,0,0,19.8,70.679Zm0,0",
    transform: "translate(2.716 -55.347)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareBtn);
export default __webpack_public_path__ + "static/media/share-btn.0efd20dd.svg";
export { ForwardRef as ReactComponent };